<template>
  <b-container fluid class="d-flex flex-column py-3">
    <b-list-group class="list-group-flush overflow-auto">
      <template v-for="item in items">
        <b-list-group-item
          :key="item.libraryNm"
          href="#"
          class="flex-column align-items-start"
          @click="onRowSelected($event, item)"
        >
          <h5 class="mb-1">{{ item.libraryText }}</h5>
          <p class="mb-1">{{ item.copyright }}</p>
        </b-list-group-item>
      </template>
    </b-list-group>
    <b-row></b-row>
    <b-modal ref="modal-license" centered ok-only scrollable :title="item.libraryText">
      <p>{{ item.copyright }}<br /><br />{{ item.fullText }}</p>
    </b-modal>
  </b-container>
</template>

<script>
import { getOssLicenseAPI } from '@/api';

export default {
  name: 'LicenseInfo',
  data() {
    return {
      items: [],
      item: []
    };
  },
  async mounted() {
    // 画面を初期化
    this.$emit('initView', { viewId: this.$options.name, useToolButtons: false });

    // OSSライセンス情報リストAPI
    const ret = await getOssLicenseAPI();
    if (!ret) {
      this.items.splice(0);
      this.$store.commit('setMessage', '通信エラー(OSSライセンスリスト取得)');
      return;
    }

    this.items = ret.data;
  },
  methods: {
    onRowSelected: function (e, item) {
      this.item = item;
      this.$refs['modal-license'].show();
    }
  }
};
</script>

<style>
div.container-fluid {
  height: 100%;
}
</style>
